import { createHttp } from '@shared/auth/http';

/**
 * Singleton axios client for learn-app. Talks to `/api` (proxied to Laravel
 * during dev via vue.config.js). Store/router are wired later in main.js
 * via bindAuth() to keep imports acyclic.
 */
export const http = createHttp({ loginRoute: '/login' });

export default http;
